import React, { useCallback, useEffect, useState } from "react";
import { Table, Button, Row, Col, Input, Pagination, Spin, App, Select, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { COURSE_REPORT, DOWNLOAD_REPORT } from "../../../apis/apis";
import moment from "moment";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { DownloadOutlined, EyeFilled, LoadingOutlined } from "@ant-design/icons";

const { Option } = Select;


const CourseReport = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);

  const [current_page, set_current_page] = useState(1);
  const [page_size, set_page_size] = useState(10);
  const [total_courses, set_total_courses] = useState("");

  const [search_query_title, set_search_query_title] = useState("");
  const [download_button, set_download_button] = useState(true);



  useEffect(() => {
    LIST_API(1, page_size, "");
  }, []);



  const LIST_API = async (page, size, search) => {
    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", size);
    if (search) formData.append("title", search);

    const API_CALL = await COURSE_REPORT(formData);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_courses(API_CALL?.data?.total_courses);
      setLoader(false);
      set_pagination_loader(false);
    } else {
      setLoader(false);
      set_pagination_loader(false);
    }
  };



  const DOWNLOAD_REPORT_ACTION = async (course_id) => {
    const formData = new FormData();
    formData.append("course_id", course_id);

    const API_CALL = await DOWNLOAD_REPORT(formData);
    if (API_CALL?.data?.status) {
      notification.success({
        message: "Successful",
        description: "Check the Download tab for your report",
      });
    }
  };



  const pagination_on_change = (page, size) => {
    set_current_page(page);
    set_page_size(size);
    set_pagination_loader(true);

    LIST_API(page, size, search_query_title);
  };



  const fetchResultsTitle = useCallback(
    debounce(async (value) => {
      set_search_query_title(value);
      set_pagination_loader(true);
      LIST_API(1, page_size, value);
    }, 500),
    [page_size]
  );

  const handleInput = (e) => fetchResultsTitle(e.target.value);




  const columns = [
    {
      title: "Created On",
      dataIndex: "created_on",
      render: (text, record) => (
        <span>{moment(record.created_on).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      title: "Course Name",
      dataIndex: "course_name",
      render: (text, record) => <span>{record.course_name}</span>,
    },

    {
      title: "Completion Rate",
      dataIndex: "completion_rate",
      render: (text, record) => (
        <span>{record.completion_rate ? `${record.completion_rate}%` : "0%"}</span>
      ),
    },
    {
      title: "Total Learners",
      dataIndex: "total_learners",
      render: (text, record) => <span>{record.total_learners}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Button
            size="small"
            variant="solid"
            color="blue"
            onClick={() =>
              navigate(`/course-learners/${btoa(record.course_id)}`, {
                state: { title: record.course_name, from: "/report/course-report" },
              })
            }
          >
            <EyeFilled />
          </Button>

          <Button
            size="small"
            style={{ marginLeft: "10px" }}
            variant="solid"
            color="green"
            onClick={() => DOWNLOAD_REPORT_ACTION(record.course_id)}
            disabled={!download_button}
          >
            <DownloadOutlined />
          </Button>
        </>
      ),
    },
  ];


  return (
    <div className="lms-body">
      <Card>
        <h2>Course Report</h2>

        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={18} lg={20}>
            <Input
              addonBefore={<span>Name</span>}
              onChange={handleInput}
              placeholder="Search by course name"
              size="large"
            />
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : pagination_loader ? (
          <div style={{ textAlign: "center", padding: "60px" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <>
            <Table
              columns={columns}
              pagination={false}
              dataSource={table_data}
              style={{ marginTop: "15px" }}
              rowKey={(record) => record.course_id}
            />

            <div style={{ float: "right", marginTop: "20px" }}>
              <Pagination
                current={current_page}
                total={total_courses}
                pageSize={page_size}
                showSizeChanger
                pageSizeOptions={[10, 20, 50, 100]}
                onChange={(page, size) => pagination_on_change(page, size)}

                onShowSizeChange={(page, size) => {
                  set_page_size(size);
                  pagination_on_change(1, size);
                }}

                className="no-search-pagination"
              />

              <style>
                {`
                .no-search-pagination .ant-select-selection-search-input {
                  display: none !important;
                }
              `}
              </style>
            </div>
          </>
        )}
      </Card>

    </div>
  );
};

export default CourseReport;
